var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSmileyWink = function SvgIconSmileyWink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 10.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13.25 10.125a1 1 0 0 1 1-1h2.25a1 1 0 1 1 0 2h-2.25a1 1 0 0 1-1-1M8.964 13.748a1 1 0 1 0-1.73 1.004 5.51 5.51 0 0 0 9.53 0 1 1 0 0 0-1.73-1.004 3.51 3.51 0 0 1-6.07 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconSmileyWink;